module.exports = __webpack_public_path__ + "static/media/icon_save_disabled.2d626f74.svg";